// extracted by mini-css-extract-plugin
export default {"container":"Wr5XZS","content":"cvByyI"};